var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M7.104 6.396a.5.5 0 1 0-.708.708L11.293 12l-4.897 4.896a.5.5 0 0 0 .708.708L12 12.707l4.896 4.897a.5.5 0 0 0 .708-.708L12.707 12l4.897-4.896a.5.5 0 0 0-.708-.708L12 11.293z",
    clipRule: "evenodd"
  })));
});
const SvgCloseCircleFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyNEMxOC42Mjc0IDI0IDI0IDE4LjYyNzQgMjQgMTJDMjQgNS4zNzI1OCAxOC42Mjc0IDAgMTIgMEM1LjM3MjU4IDAgMCA1LjM3MjU4IDAgMTJDMCAxOC42Mjc0IDUuMzcyNTggMjQgMTIgMjRaTTcuMTAzNTUgNi4zOTY0NUM2LjkwODI5IDYuMjAxMTggNi41OTE3MSA2LjIwMTE4IDYuMzk2NDUgNi4zOTY0NUM2LjIwMTE4IDYuNTkxNzEgNi4yMDExOCA2LjkwODI5IDYuMzk2NDUgNy4xMDM1NUwxMS4yOTI5IDEyTDYuMzk2NDUgMTYuODk2NEM2LjIwMTE4IDE3LjA5MTcgNi4yMDExOCAxNy40MDgzIDYuMzk2NDUgMTcuNjAzNkM2LjU5MTcxIDE3Ljc5ODggNi45MDgyOSAxNy43OTg4IDcuMTAzNTUgMTcuNjAzNkwxMiAxMi43MDcxTDE2Ljg5NjQgMTcuNjAzNkMxNy4wOTE3IDE3Ljc5ODggMTcuNDA4MyAxNy43OTg4IDE3LjYwMzYgMTcuNjAzNkMxNy43OTg4IDE3LjQwODMgMTcuNzk4OCAxNy4wOTE3IDE3LjYwMzYgMTYuODk2NEwxMi43MDcxIDEyTDE3LjYwMzYgNy4xMDM1NUMxNy43OTg4IDYuOTA4MjkgMTcuNzk4OCA2LjU5MTcxIDE3LjYwMzYgNi4zOTY0NUMxNy40MDgzIDYuMjAxMTggMTcuMDkxNyA2LjIwMTE4IDE2Ljg5NjQgNi4zOTY0NUwxMiAxMS4yOTI5TDcuMTAzNTUgNi4zOTY0NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";